@if (currentUser()) {
  <div
    class="flex cursor-pointer items-center gap-3 rounded-lg p-2 transition-all duration-200 hover:bg-greyscale-100"
    (click)="op.toggle($event)"
    (keydown.enter)="op.toggle($event)"
    (keydown.space)="op.toggle($event); $event.preventDefault()"
    tabindex="0"
    role="button"
    aria-haspopup="true"
  >
    <p-avatar
      [label]="currentUser()!.initials"
      size="normal"
      shape="circle"
      [style]="{
        'background-color': 'var(--color-greyscale-900)',
        'color': 'white',
        'font-weight': '600',
        'font-size': '14px'
      }"
    />
    <div class="flex-1 overflow-hidden">
      <div class="truncate font-source-sans text-sm font-semibold text-greyscale-950">
        {{ currentUser()!.firstName }} {{ currentUser()!.lastName }}
      </div>
      <div class="truncate font-source-sans text-xs text-greyscale-600">
        {{ currentUser()!.companyName }}
      </div>
    </div>
    <i class="pi pi-chevron-down text-xs text-greyscale-500"></i>
  </div>
}

<p-popover #op [style]="{ 'min-width': '180px' }">
  <div class="flex flex-col gap-1 p-2">
    @for (red of redirection; track $index) {
      <button
        (click)="redirectTo(red.redirect)"
        class="flex w-full cursor-pointer items-center gap-2 rounded-md border-0 bg-transparent px-3 py-2 text-left font-source-sans text-sm text-greyscale-700 transition-all duration-200 hover:bg-greyscale-100 hover:text-greyscale-900"
      >
        <i [class]="red.icon" class="text-sm"></i>
        <span>{{ red.name | transloco }}</span>
      </button>
    }
  </div>
</p-popover>
